<template>
    <div class="bg-white rounded pb-1-3rem">
        <h3 class="font-weight-bold px-3 f-20 pt-4 text-left mb-3 text-black">{{ $t('subscriptions.title') }}</h3>
        <p class="font-weight-bold mb-2 text-left px-3">{{ $t('subscriptions.manageSubscription') }}</p>
        <p class="px-3 text-left mb-2 text-grey">{{ $t('subscriptions.manageDescription') }}</p>
        <div class="mt-3 text-left px-3 pb-3">
            <b-button btn class="save mx-0 mb-0 h-40px w-125px" variant="primary"
                @click="getSubscriptionDetailsUrl"
                    >{{ $t('subscriptions.billingPortal') }}</b-button>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: 'Subscriptions',
    methods:{
        ...mapActions(['getSubscriptionDetails']),
            async getSubscriptionDetailsUrl(){
                try{
                    const url = await this.getSubscriptionDetails();
                    if(url) window.location.href = url
                }
                catch(e){
                    console.log(e)
                }
            }
    }

}
</script>